import React from 'react';
import './Catering.css';

const cateringData = {
    "Appetizers": [
        { name: "Wings (4lb - 48 pcs)", price: "", description: "Traditional wings baked until golden, tossed with Buffalo Or BBQ, served with ranch" },
        { name: "Meatballs", price: "Small (6-8) $55 | Large (20-25) $90", description: "Meatballs with marinara and mozzarella cheese" },
        { name: "Garlic Bread", price: "", description: "Open face 6” bread loaf topped with fresh garlic spread and mozzarella cheese baked in the oven, garnished with parmesan cheese, oregano, and parsley" }
    ],
    "Calzones": [
        { name: "Tomato & Mushroom", price: "", description: "With Tomatoes & Mushrooms" },
        { name: "Tuscan", price: "", description: "With feta cheese, sun dried tomatoes & kalamata olives" },
        { name: "Greek", price: "", description: "With feta cheese & kalamata olives" },
        { name: "Build Your Own", price: "", description: "Choose from our pizza toppings. First 4 toppings are free. Add $3 per additional topping" }
    ],
    "Salads": [
        { name: "House Salad", price: "Small (10-15) $45 | Large (30-35) $85", description: "Lettuce, red onions, tomatoes, cucumbers, Kalamata olives, croutons, balsamic vinaigrette dressing" },
        { name: "Spinach Salad", price: "Small (10-15) $45 | Large (30-35) $85", description: "Spinach, red onions, tomatoes feta cheese, ranch dressing" },
        { name: "Village Salad", price: "Small (10-15) $50 | Large (30-35) $95", description: "Lettuce, red onions, tomatoes, cucumbers, Kalamata olives, croutons, feta cheese, and balsamic vinaigrette dressing" },
        { name: "Caesar Salad", price: "Small (10-15) $45 | Large (30-35) $85", description: "Romaine, Croutons, Shredded Parmesan cheese, lemon juice, caesar dressing" }
    ],
    "Pasta": [
        { name: "Penne Bolognese", price: "Small (10-15) $65 | Large (30-35) $115", description: "Penne pasta tossed with beef Bolognese sauce, topped with parmesan cheese and parsley" },
        { name: "Pesto Alfredo Penne", price: "Small (10-15) $65 | Large (30-35) $115", description: "Penne pasta, tossed with pesto and alfredo sauce, topped with parmesan cheese and basil" },
        { name: "Creamy Pesto Fusilli", price: "Small (10-15) $70 | Large (30-35) $125", description: "Fusilli pasta, mushrooms, artichoke, cherry tomatoes, red onions, Sun-dried tomatoes, topped with parmesan cheese, green onions and parsley" },
        { name: "Lasagna", price: "Small (10-15) $75 | Large (30-35) $130", description: "Lasagna layered pasta with beef Bolognese, mozzarella, ricotta, fresh mozzarella" }
    ],
    "Burgers": [
        { name: "Burger Tray", price: "Small (4) $54 | Large (8) $110", description: "Cheeseburgers" },
        { name: "Hamburger Tray", price: "Small (4) $50 | Large (8) $100", description: "Hamburgers" },
        { name: "Sliders Tray", price: "Small (9) $40 | Large (18) $80", description: "Beef sliders" },
        { name: "Chicken Sliders Tray", price: "Small (9) $31 | Large (18) $63", description: "Crispy chicken sliders" }
    ],
    "Mini Sandwiches": [
        { name: "Chicken Parmigiana", price: "Small (16) $56 | Large (40) $140", description: "Mozzarella, parmesan cheese, and marinara sauce." },
        { name: "Meatball Parmigiana", price: "Small (16) $56 | Large (40) $140", description: "Mozzarella, parmesan cheese, and marinara sauce" },
        { name: "Philly Cheesesteak", price: "Small (16) $56 | Large (40) $140", description: "Strip loin, sautéed onion, green peppers, mushrooms, with provolone cheese." }
    ],
    "Pizza Creation": [
        { name: "Cheese Pizza", price: "M $22 | L $27 | Wagon $32 | GF $27", description: "Build your own pizza base" },
        { name: "Additional Toppings", price: "M $3 | L $4 | Wagon $6 | GF $3", description: "Vegetables, Fruits, Meats, Cheeses, Sauces" }
    ],
    "Specialty Pizza": [
        { name: "Margherita", price: "14\" $32 | 16\" $40 | 20\" $45 | GF $36", description: "Olive oil, tomatoes, roasted peppers, fresh basil, balsamic glaze" },
        { name: "Meat Lovers", price: "14\" $34 | 16\" $42 | 20\" $49 | GF $39", description: "Marinara, salami, pepperoni, ham, bacon, Italian sausage" },
        { name: "BBQ Chicken", price: "14\" $34 | 16\" $42 | 20\" $49 | GF $39", description: "BBQ sauce, roasted chicken, bacon, green onions, red onions" },
        { name: "Combination", price: "14\" $35 | 16\" $44 | 20\" $52 | GF $41", description: "Marinara, salami, pepperoni, mushrooms, green peppers, red onions, Italian sausage" },
        { name: "Vegetarian", price: "14\" $36 | 16\" $45 | 20\" $53 | GF $42", description: "Marinara, mushrooms, green peppers, red onions, black olives, tomatoes, garlic" },
        { name: "Chicken Pesto", price: "14\" $27 | 16\" $34 | 20\" $42 | GF $34", description: "Pesto sauce, chicken" },
        { name: "SF Hole in the Wall", price: "14\" $27 | 16\" $34 | 20\" $42 | GF $31", description: "Marinara, ham, pineapple" },
        { name: "Spicy Hawaiian", price: "14\" $32 | 16\" $40 | 20\" $46 | GF $37", description: "Marinara, ham, bacon, pineapples, jalapeño peppers" },
        { name: "Greek Pizza", price: "14\" $38 | 16\" $47 | 20\" $55 | GF $44", description: "Pesto sauce, spinach, feta cheese, garlic, fresh basil, fresh tomatoes, roasted peppers" }
    ],
    "Dessert": [
        { name: "Dessert Tray", price: "", description: "24 Pieces" }
    ]
};

const Catering = () => {
    return (
        <div className="catering-page container">
            <h1 className="catering-title">Catering Menu</h1>
            <div className="catering-intro">
                <p>Catering to all events and party sizes.</p>
            </div>
            {Object.keys(cateringData).map((section) => (
                <div key={section} className="catering-section">
                    <h2 className="section-title">{section}</h2>
                    <div className="catering-items">
                        {cateringData[section].map((item, index) => (
                            <div key={index} className="catering-item-card">
                                <div className="item-header">
                                    <h3 className="item-name">{item.name}</h3>
                                    {item.price && <span className="item-price">{item.price}</span>}
                                </div>
                                <p className="item-description">{item.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Catering;
